import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';


import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import GeneralCostInfo from './GeneralCostInfo';
import GenericCostInfo from './GenericCostInfo';
import MaterialCostInfo from './MaterialCostInfo';
import DetailCostInfo from './DetailCostInfo';
import OtherCostInfo from './OtherCostInfo';
import SubcontractCostInfo from './SubcontractCostInfo';


import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';


//Progress
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  CREATE_PROJECT_MODEL_ACTION_CREATE,
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  COST_TYPE_LABOR,
  COST_TYPE_EQUIPMENT,
  COST_TYPE_MATERIAL,
  COST_TYPE_OTHER,
  COST_TYPE_SUBCONTRACT
} 
from '../common/redux/constantes';

import moment from 'moment';
import momentc from 'moment-weekday-calc';





//validators
import {validateField,validateDecimalNumberWithLimit,validateDates,validateIntegerNumberWithLimit} from '../common/redux/validators';
const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = [
  'General',
  'Data',
  'Period'
];



class CreateCost extends Component {


  constructor(props)
  {
    super(props);

    //Bindings
    this.getStepContent = this.getStepContent.bind(this);
    this.handleChange=this.handleChange.bind(this);
    this.saveCost=this.saveCost.bind(this);
    this.consultarCatalogos = this.consultarCatalogos.bind(this);
    this.getWp = this.getWp.bind(this);
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    //Primer estado
    let cost = {
      control_account:this.props.ca,
      workpackage:this.props.workpackage, //Id del workpackage
      project:this.props.project,
      type:COST_TYPE_LABOR,
      sunday_selected:0,
      saturday_selected:0,
    };



    let activeStep = 0;

     //Config moment-weekday-calc
    let f = momentc;
    if(!f){
      //No se pudo configurar moment weekday calc
      console.log("No se pudo configurar moment weekday calc");
    }

    
    //Si está editando o viendo la info
    if(this.props.actionDialog !== CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      cost = this.props.costEdit;
      this.setState({cost:cost});
    }

    this.state = {
      workpackage_name:this.props.workpackage_name,
      activeStep: activeStep,
      cost:cost,
      cost_catalogs:[],
      errores:{}
    }; 


  }

  static propTypes = {
    cost: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount()
  {

    this.setState({workpackage_name:this.props.workpackage_name})
    this.getWp();
    this.consultarCatalogos();
  }

  getWp()
  {
    this.props.actions.fetchWorkpackages(this.props.deliverable)
    .then(res=>{
      if(res.data.workpackages && res.data.workpackages.length>0)
      {
        let workpackages = res.data.workpackages.map(workpackage=>{
          let w = {};
          w.workpackage = w.value =workpackage.workpackage;
          w.name = w.label= workpackage.name;
          return w;
        });
        this.setState({
          workpackages: workpackages
        });
      }
    });
  }

  consultarCatalogos(cost_reset)
  {
    //Consultar los catalogos 
    this.props.actions.fetchCostCatalog(this.props.project)
    .then(res=>{
      if(res.data.cost_catalogs && res.data.cost_catalogs.length>0)
      {
        let cost_catalogs = res.data.cost_catalogs.map(cost_catalog=>{
          let w = {};
          w.cost_catalog = w.value =cost_catalog.cost_catalog;
          w.name = w.label= cost_catalog.name;
          return w;
        });
        this.setState({
          cost_catalogs: cost_catalogs,
        });
        if(cost_reset)
        {
          this.setState({
            cost:cost_reset,
            activeStep: 0,
          });
        }
      }
    });

  }


  getStepContent(step) 
  {
    switch (step) {
      case 0:
        return <GeneralCostInfo 
          handleChange={this.handleChange} 
          errores={this.state.errores} 
          costinfo={this.state.cost}
          cost_catalogs={this.state.cost_catalogs}
          reviewActive={(this.props.actionDialog !== CREATE_PROJECT_MODEL_ACTION_CREATE )}/>;
      case 1:
        switch(this.state.cost.type)
        {
          case COST_TYPE_MATERIAL:
            return <MaterialCostInfo  
              handleChange={this.handleChange} 
              errores={this.state.errores} 
              costinfo={this.state.cost} 
              reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
          case COST_TYPE_OTHER:
            return <OtherCostInfo  
              handleChange={this.handleChange} 
              errores={this.state.errores} 
              costinfo={this.state.cost} 
              reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
          case COST_TYPE_SUBCONTRACT:
            return <SubcontractCostInfo  
              handleChange={this.handleChange} 
              errores={this.state.errores} 
              costinfo={this.state.cost} 
              reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
          default:
            return <GenericCostInfo  
              handleChange={this.handleChange} 
              errores={this.state.errores} 
              costinfo={this.state.cost} 
              reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
        }
        case 2:
          return <DetailCostInfo 
            handleChange={this.handleChange} 
            errores={this.state.errores} 
            costinfo={this.state.cost} 
            reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
        
      default:
        throw new Error('Unknown step');
    }
  }

   handleNext = () => {
    if(steps.length - 1 === this.state.activeStep && this.props.actionDialog!==CREATE_PROJECT_MODEL_ACTION_SHOW)
    {
      //Solo puede guardar si está valido el form
      if(!this.validateForm())
      {
        return;
      }

      //Si es el último step hay que guardar el project. 
      this.saveCost();
    }
    else if(steps.length - 1 === this.state.activeStep)
    {
      //Por petición se hizo que si está sólo mostrando datos en el botón next se cierre la pantalla.
      this.props.onCloseAction();
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };


  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleChange(event) 
  {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;

    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let cost = this.state.cost;
    cost[name] = value;
    //validamos fechas antes de recalcular dias y costos
    let cdd = validateField(cost.start_date) && validateField(cost.finish_date);
    cdd = cdd & validateDates(cost.finish_date,cost.start_date, 4);
    if(cdd)
    {
      let work_days = [1,2,3,4,5];
      //Se calcula con domingo
      if(cost.sunday_selected)
        work_days.push(0);
      //Se calcula con sabado
      if(cost.saturday_selected)
        work_days.push(6);

      //Calculamos cuantos dias tiene el rango de fechas
      let number_days = moment().weekdayCalc(cost.start_date,cost.finish_date,work_days);
      cost.number_days = number_days;
      if(this.state.cost.type === COST_TYPE_LABOR || this.state.cost.type === COST_TYPE_EQUIPMENT)
      {
        let total_cost = 0;
        //Obtenemos datos del costo
        let journey = parseFloat(this.state.cost.journey).toFixed(2);
        let hourly_rate = parseFloat(this.state.cost.hourly_rate).toFixed(2);
        //Al principio los dias son de lunes a viernes
        let daily_cost = journey * hourly_rate;
        //Calculamos el costo
        total_cost = number_days * daily_cost;
        //Seteamos los datos
        cost.total_cost = total_cost.toFixed(2);
        cost.daily_cost = daily_cost.toFixed(2);
      }else if(this.state.cost.type === COST_TYPE_MATERIAL)
      {
        // calculo inicial. 
        // cost.daily_cost = 0;
        cost.total_cost = (this.state.cost.quantity * this.state.cost.price).toFixed(2);
        // segundo calculo
        cost.daily_cost = number_days > 0 ? (cost.total_cost/number_days).toFixed(2) : 0;
      }else if(this.state.cost.type === COST_TYPE_SUBCONTRACT)
      {
        // calculo inicial
        // cost.daily_cost = 0;
        cost.total_cost = parseFloat(this.state.cost.price).toFixed(2);
        // segunda calculo
        cost.daily_cost = number_days > 0 ? (cost.total_cost/number_days).toFixed(2) : 0;
      }else if(this.state.cost.type === COST_TYPE_OTHER)
      {
        let total_cost = 0;
        //Obtenemos datos del costo
        let quantity = parseFloat(this.state.cost.quantity).toFixed(2);
        let price = this.state.cost.price;
        //Calculamos el costo
        total_cost =  price * quantity;
        //Seteamos los datos
        cost.total_cost = total_cost.toFixed(2);
        cost.daily_cost = ((  price * quantity) / number_days ).toFixed(2);
      }
    }

    
    this.setState({
      cost: cost
    });
    this.validateForm();
  }


  
  validateForm()
  {
    let valido = false;
    switch(this.state.cost.type)
    {
      case COST_TYPE_MATERIAL:
        valido =  this.validateMaterialForm();
        break;
      case COST_TYPE_OTHER:
        valido = this.validateOtherForm();
        break;
      case COST_TYPE_SUBCONTRACT:
        valido = this.validateSubcontractForm();
        break;
      default:
        valido = this.validateGenericForm();
        break;
    }
    if(valido)
    {
      return this.validateCostDetailForm();
    }else
    {
      return false;
    }
  }

   validateCostDetailForm = ()=>{
    let errores = {};
    let valido = true;
    let cost = {
      start_date:'',
      finish_date:'',
      sunday_selected:'',
      saturday_selected:'',
      number_days:'',
      total_cost:'',
      daily_cost:'',
      workpackage:''
    };

    if (!validateField(this.state.cost.description) && !validateField(this.state.cost.cost_catalog)) 
    {
      errores.description= 'Required field';
      errores.cost_catalog= 'Required field';
      valido = false;
    }


    if(!validateDecimalNumberWithLimit(this.state.cost.total_cost, 10))
    {
      errores.total_cost = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }


    /*if(!validateDecimalNumberWithLimit(this.state.cost.daily_cost, 10))
    {
      errores.daily_cost = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }*/

    if(!validateIntegerNumberWithLimit(this.state.cost.number_days,11))
    {
      errores.number_days = "Incorrect format (Max: 11 digits)";
      valido = false;
    }

    //finish_date >= start_date
    if(!validateDates(this.state.cost.finish_date,this.state.cost.start_date, 4))
    {
      errores.finish_date = 'Must be greather than start date';
      valido = false;
    }



    //Validando atributos almenos ingresados
    for (const attribute in cost) 
    {
      if (!validateField(this.state.cost[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }
  
  validateSubcontractForm = ()=>{
    let errores = {};
    let valido = true;
    let cost = {
      price:'',
      period_type:''
    };


    if(!validateDecimalNumberWithLimit(this.state.cost.price, 10))
    {
      errores.price = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }

    //Validando atributos almenos ingresados
    for (const attribute in cost) 
    {
      if (!validateField(this.state.cost[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }


  validateOtherForm = ()=>{
    let errores = {};
    let valido = true;
    let cost = {
      unit:'',
      price:'',
      quantity:'',
      control_account:''
    };

    if(!validateDecimalNumberWithLimit(this.state.cost.price, 8))
    {
      errores.price = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }

    if(!validateDecimalNumberWithLimit(this.state.cost.quantity, 8))
    {
      errores.quantity = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }


    //Validando atributos almenos ingresados
    for (const attribute in cost) 
    {
      if (!validateField(this.state.cost[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }

    this.setState({
      errores: errores,
    });
    return valido;
  }



  validateMaterialForm = ()=>{
    let errores = {};
    let valido = true;
    let cost = {
      unit:'',
      quantity:'',
      price:'',
      control_account:''
    };


    //Validando decimales en jorney
    if(!validateDecimalNumberWithLimit(this.state.cost.price, 8))
    {
      errores.price = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }

    if(!validateDecimalNumberWithLimit(this.state.cost.quantity, 8))
    {
      errores.quantity = "Incorrect format (Max: 10 digits, 2 decimals)";
      valido = false;
    }


    //Validando atributos almenos ingresados
    for (const attribute in cost) 
    {
      if (!validateField(this.state.cost[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }

    this.setState({
      errores: errores,
    });
    return valido;
  }


  validateGenericForm = ()=>
  {
    let errores = {};
    let valido = true;
    let cost = {
      journey:'',
      hourly_rate:''
    };


    //Validando decimales en jorney
    if(!validateDecimalNumberWithLimit(this.state.cost.journey, 4))
    {
      errores.journey = "Incorrect format (Max: 4 digits, 2 decimals)";
      valido = false;
    }

    if(!validateDecimalNumberWithLimit(this.state.cost.hourly_rate, 6))
    {
      errores.hourly_rate = "Incorrect format (Max: 6 digits, 2 decimals)";
      valido = false;
    }

    //Validando atributos almenos ingresados
    for (const attribute in cost) 
    {
      if (!validateField(this.state.cost[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }

    let serrores = {};
    serrores = errores;
    this.setState({
      errores: serrores,
    });
    return valido;
  }

  saveCost(){
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      //Create Control Account
      this.props.actions.saveCost(this.state.cost,CREATE_PROJECT_MODEL_ACTION_CREATE );
    }
    else
    {
      //Edit Control Account
      this.props.actions.saveCost(this.state.cost,CREATE_PROJECT_MODEL_ACTION_EDIT );
    }
  }

  handleReset = () => {
    let cost = this.state.cost;
    cost.cost_catalog = this.props.cost.costN?this.props.cost.costN.cost_catalog:cost.cost_catalog;

    this.consultarCatalogos(cost);
    
  };

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }

  closeDialog()
  {
    this.props.onCloseAction();
  }


  handleChangeSelection(val)
  {
    let cost = this.state.cost;
    cost.workpackage = val.workpackage;
    this.setState({cost:cost, workpackage_name:val.name});
  }

  render() {
    
    const { classes } = this.props;
    const {savePending, fragmentContent,fragmentTitle } = this.props.cost;
    const {activeStep} = this.state;
    let title = "Cost Information";
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE){
      title =  "Create Cost";
    }else if (this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_EDIT){
      title = "Update Cost";
    }
    let wp_title = "Worpackage: " + this.state.workpackage_name + "";
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              {title}
            </Typography>

            <br/>
          <Typography component="h6" variant="h6" align="center">
              {wp_title}
            </Typography>

            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <div>
                  {savePending ? 
                  (
                    <CircularProgress />
                  ):(
                    <React.Fragment>
                      <Typography variant="h5" gutterBottom>
                        {fragmentTitle}
                      </Typography>
                      <Typography variant="subtitle1" color={this.props.cost.saveCostError===-1?"secondary":"initial"} >
                      {fragmentContent}
                      </Typography>
                      <br/>
                      {this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE && this.props.cost.saveCostError!==-1?
                        (
                          <div>
                            <Typography variant="subtitle1">
                              Do you want to add the cost to other workpackage?
                            </Typography>
                            <br/>
                            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Work Package</InputLabel>
                              <Select
                                required
                                id="workpackage"
                                name="workpackage"
                                value={this.getValueCatalog(this.state.workpackages,this.state.cost.workpackage)}
                                onChange={this.handleChangeSelection}
                                options={this.state.workpackages}
                              >
                              </Select>
                            <Button
                              onClick={this.handleReset}
                              className={classes.button}
                              color="primary"
                            >
                              Yes
                            </Button>
                            <Button
                              onClick={this.closeDialog}
                              className={classes.button}
                              color="primary"
                            >
                              No
                            </Button>
                          </div>
                        ):null
                      }
                       
                    </React.Fragment>
                     
                  )}
                </div>
              ) : (
                <React.Fragment>
                  {this.getStepContent(activeStep)}
                  <div className={classes.buttons}>
                    {(activeStep !== 0) && (
                      <Button
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                    )}
                    {(true) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      > 
                        {activeStep === steps.length - 1 ? this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_SHOW? "Close":"Save" : "Next"}
                      </Button>
                    )}
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    cost: state.cost,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CreateCost));


// WEBPACK FOOTER //
// ./src/features/cost/CreateCost.js